export const summaryRows: string[] = [
  'Volume 01 — Pharmaceutical Manufacturing Fundamentals: Dosage Forms, the Production Flow & the Plant',
  'Volume 02 — GMP & the Pharmaceutical Quality System: Documentation, Deviations, CAPA & Change Control',
  'Volume 03 — Cleanrooms & Contamination Control: Classification, HVAC, Gowning & Environmental Monitoring',
  'Volume 04 — Solid & Liquid Dosage Manufacturing: Granulation, Compression, Coating, Encapsulation & Liquids',
  'Volume 05 — Sterile Manufacturing & Aseptic Processing: Sterilization, Aseptic Filling & Lyophilization',
  'Volume 06 — Validation, Qualification, Data Integrity, Audits & Inspections',
  'Bonus 1 — Good Documentation Practice (GDocP) Quick Guide',
  'Bonus 2 — Deviation Investigation & Root Cause Analysis Field Guide',
  'Bonus 3 — Cleanroom Gowning & Aseptic Behavior Visual Guide',
  'Bonus 4 — Tablet, Capsule & Coating Defects Troubleshooting Atlas',
  'Bonus 5 — Pharmaceutical Manufacturing & GMP Terminology Dictionary',
  '7-day money-back guarantee',
  'Instant access',
];
